"use client";

import type { TutorialMission } from "@/constants/tutorialMissions";
import { HOME_TOUR_START_EVENT, requestHomeTour } from "@/lib/guide/homeTour";
import { getBrowserStorage, writeActiveMission } from "@/lib/tutorial/activeMission";

/**
 * 「やってみる」/「次のミッションへ」でミッションを始める。
 * - ホームの使い方ツアーのミッション: ツアーを開く (ホーム以外ではホームへ移ってから)
 * - それ以外: 画面の下に手順の案内を出す (どの画面でも出続ける)
 */
export function startTutorialMission(
  mission: TutorialMission,
  nav: { pathname: string; push: (href: string) => void },
): void {
  const session = getBrowserStorage("session");
  if (mission.start === "tour") {
    writeActiveMission(session, null);
    requestHomeTour(session);
    if (nav.pathname.startsWith("/home")) {
      window.dispatchEvent(new Event(HOME_TOUR_START_EVENT));
    } else {
      nav.push("/home");
    }
    return;
  }
  writeActiveMission(session, { key: mission.key, manualIndex: 0 });
}
